export const form_container = {
  data() {
    return {
      formname: 'form',
    }
  },
  methods: {
    handleOpened(formname='form') {
      this.formname = formname;
      this.$refs[this.formname].opened();
    },
    beforeClose(done) {
      if (!this.$refs[this.formname]) { done(true); }
      if (this.$refs[this.formname].hasChange()) {
        this.util.confirm_leave(this, "", () => done(true));
      } else {
        done(true);
      }
    },
  }
}